import React, { useState } from 'react';
import '../../Assets/Styles/Custom.css';
import './searchHits.css';
import searchHitsData from './searchHitsData.json';
import { rightArrowBorder } from '../../Assets'

function SearchHits() {
  const [activeTab, setActiveTab] = useState('hits'); // 'hits' or 'stats'

  const { directHitsData, tpConnectData, statsData } = searchHitsData;

  const grandTotal = statsData.reduce((acc, apiGroup) => {
    return acc + apiGroup.subRows.reduce((subAcc, row) => subAcc + row.total, 0);
  }, 0);

  const renderRoute = (airports) => (
    <div className="route-flow">
      {airports.map((airport, index) => (
        <React.Fragment key={index}>
          <span className="airport-code">{airport}</span>
          {index < airports.length - 1 && <span className="arrow"><img src={rightArrowBorder} alt="Arrow" /></span>}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className="searchHits--container hotel-proxima">
      <div className="width-container">
        
        {/* Header Navigation Controls */}
        <div className="global-header-controls">
          <div className="tab-group">
            <button 
              className={`tab-btn ${activeTab === 'hits' ? 'active' : ''}`}
              onClick={() => setActiveTab('hits')}
            >
              View Hits
            </button>
            <button 
              className={`tab-btn ${activeTab === 'stats' ? 'active' : ''}`}
              onClick={() => setActiveTab('stats')}
            >
              View Stats
            </button>
          </div>
        </div>

        {activeTab === 'hits' ? (
          <>
            {/* Direct Hit’s (Oneway) Section */}
            <section className="hits-section">
              <h2 className="section-title">Direct Hit’s (Oneway):</h2>
              <table className="hits-table">
                <thead>
                  <tr>
                    <th className="col-type">Hits Type</th>
                    <th className="col-hits">Hits</th>
                  </tr>
                </thead>
                <tbody>
                  {directHitsData.map((group, groupIdx) => (
                    <React.Fragment key={groupIdx}>
                      {group.routes.map((route, routeIdx) => (
                        <tr 
                          key={routeIdx} 
                          className={routeIdx === 0 && groupIdx !== 0 ? 'group-divider' : ''}
                        >
                          <td className="type-cell">
                            {routeIdx === 0 ? group.type : ''}
                          </td>
                          <td className="hits-cell">
                            {renderRoute(route)}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </section>

            {/* TP-Connect (Oneway) Section */}
            <section className="hits-section">
              <h2 className="section-title">TP-Connect (Oneway):</h2>
              <table className="hits-table">
                <thead>
                  <tr>
                    <th className="col-type">Options</th>
                    <th className="col-hits">Hits</th>
                  </tr>
                </thead>
                <tbody>
                  {tpConnectData.map((group, groupIdx) => (
                    <React.Fragment key={groupIdx}>
                      {group.routes.map((route, routeIdx) => (
                        <tr key={routeIdx}>
                          <td className="type-cell">
                            {routeIdx === 0 ? group.option : ''}
                          </td>
                          <td className="hits-cell">
                            {renderRoute(route)}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </section>
          </>
        ) : activeTab === 'stats' ? (
          <section className="hits-section">
            <h2 className="section-title">Hit Statistics (Oneway):</h2>
            <table className="hits-table stats-table">
              <thead>
                <tr>
                  <th className="col-api">API</th>
                  <th className="col-type1">Type</th>
                  <th className="col-type2">Type</th>
                  <th>India</th>
                  <th>Canada</th>
                  <th>Dubai</th>
                  <th>Singapore</th>
                  <th className="text-center">Total</th>
                </tr>
              </thead>
              <tbody>
                {statsData.map((apiGroup, groupIdx) => (
                  <React.Fragment key={groupIdx}>
                    {apiGroup.subRows.map((row, rowIdx) => {
                      const isLastInGroup = rowIdx === apiGroup.subRows.length - 1;
                      return (
                        <tr 
                          key={rowIdx} 
                          className={isLastInGroup ? 'group-bottom-border' : ''}
                        >
                          <td className="type-cell">
                            {rowIdx === 0 ? apiGroup.api : ''}
                          </td>
                          <td className="subtext-cell">
                            {rowIdx === 0 ? apiGroup.type1 : ''}
                          </td>
                          <td className="subtext-cell">{row.type2}</td>
                          <td>{row.india}</td>
                          <td>{row.canada}</td>
                          <td>{row.dubai}</td>
                          <td>{row.singapore}</td>
                          <td className="text-center">
                            <span className="total-badge">{row.total}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ))}
              </tbody>
              <tfoot>
                <tr className="stats-footer-row">
                  <td colSpan="7" className="footer-label">Total:</td>
                  <td className="text-center footer-value">{grandTotal}</td>
                </tr>
              </tfoot>
            </table>
          </section>
        ) : null}

      </div>
    </div>
  );
}

export default SearchHits;